__turbopack_context__.v({
  "icon": "ProductInfo-module__NQc5KW__icon",
  "infoCard": "ProductInfo-module__NQc5KW__infoCard",
  "infoContent": "ProductInfo-module__NQc5KW__infoContent",
  "infoItem": "ProductInfo-module__NQc5KW__infoItem",
  "label": "ProductInfo-module__NQc5KW__label",
  "value": "ProductInfo-module__NQc5KW__value",
});
